import { SUPPORTED_RANKING_TYPES } from "./constants";
import type { ParsedRankingReference, RankingType } from "../types";

export class RankingUrlError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "RankingUrlError";
  }
}

export function parseRankingUrl(input: string): ParsedRankingReference {
  let url: URL;
  try {
    url = new URL(input.trim());
  } catch {
    throw new RankingUrlError("網址格式不正確，請貼上完整的 TATTA 排行榜網址。");
  }

  if (url.protocol !== "https:" || url.hostname !== "tatta.runnet.jp") {
    throw new RankingUrlError("只接受 tatta.runnet.jp 的 HTTPS 排行榜網址。");
  }

  const match = url.pathname.match(/^\/rankings\/([1-9]\d*)\/([^/]+)\/?$/);
  if (!match) {
    throw new RankingUrlError(
      "網址路徑應為 /rankings/{賽事 ID}/{排行榜類型}。",
    );
  }

  const raceId = Number(match[1]);
  const rankingType = match[2];
  if (!SUPPORTED_RANKING_TYPES.includes(rankingType as RankingType)) {
    throw new RankingUrlError(
      `目前尚未支援「${rankingType}」，可使用的類型為 distance-challenge。`,
    );
  }

  return {
    raceId,
    rankingType: rankingType as RankingType,
    eventKey: `${rankingType}:${raceId}`,
    sourceUrl: `https://tatta.runnet.jp/rankings/${raceId}/${rankingType}`,
  };
}
